import React from 'react';
import { CivilDate } from 'tc39-proposal-temporal';
import { WithManagedFocuser } from '@bingads-webui-react/hoc-with-managed-focuser';
import { submitEvent } from '@bingads-webui-universal/accessibility-helper';
import PropTypes from 'prop-types';

class DayItemInternal extends React.PureComponent {
  onFocusHandler = () => {
    this.props.focusItemCallback(this.props.date);
  }

  render() {
    const {
      day,
      i18n,
      formatDay,
      formatMonthDayYear,
      dayClass,
      focusableRef,
      focusThis,
      isInSelectedRange,
    } = this.props;

    return (
      <td
        key={day.key}
        ref={focusableRef}
        role="gridcell"
        tabIndex={day.isFirstDayOfMonth ? '0' : '-1'}
        data-value={formatDay(day.originalDate, i18n)}
        className={`dayWrapper ${dayClass}`}
        onClick={focusThis && day.isInBounds ? day.onSelected : undefined}
        aria-label={formatMonthDayYear(
          day.originalDate,
          i18n
        )}
        onKeyDown={day.isInBounds ?
          event => submitEvent(day.onSelected)({ keyCode: event.which }) :
          undefined}
        onFocus={this.onFocusHandler}
        aria-selected={isInSelectedRange}
      >
        <button
          type="button"
          key={`${day.key} div`}
          className="day"
          aria-label={formatMonthDayYear(
            day.originalDate,
            i18n
          )}
          tabIndex="-1"
          data-is-focusable={day.isInBounds ? true : undefined}
          disabled={!day.isInBounds || !day.isInMonth}
        >
          <span aria-hidden="true">{formatDay(day.originalDate, i18n)}</span>
        </button>
      </td >
    );
  }
}

DayItemInternal.propTypes = {
  day: PropTypes.shape({
    key: PropTypes.string,
    isInBounds: PropTypes.bool,
    onSelected: PropTypes.func,
    isSelected: PropTypes.bool,
    isToday: PropTypes.bool,
    isInMonth: PropTypes.bool,
    date: PropTypes.number,
    originalDate: PropTypes.instanceOf(CivilDate),
  }).isRequired,
  formatMonthDayYear: PropTypes.func.isRequired,
  formatDay: PropTypes.func.isRequired,
  i18n: PropTypes.shape({}).isRequired,
  dayClass: PropTypes.string.isRequired,
  focusItemCallback: PropTypes.func.isRequired,
  focusableRef: PropTypes.func,
  date: PropTypes.instanceOf(Date).isRequired,
  focusThis: PropTypes.func.isRequired,
  isInSelectedRange: PropTypes.bool,
};

DayItemInternal.defaultProps = {
  focusableRef: null,
  isInSelectedRange: undefined,
};

export const DayItem = WithManagedFocuser(DayItemInternal);
